<script>
 import Tepe from './Tepe.svelte'
 import Alt from './Alt.svelte'
 import Ayarlar from './Ayarlar.svelte'
 import Diller from './Diller.svelte'
 import Muhteva from './Muhteva.svelte'
</script>

<!-- üst bölüm -->
 <Tepe />
 <h1>Merhaba</h1>

<div class="satır">
  <div class="sütun-3 sütun-k-3 ayarlar">
    <!-- ayarlar bölümü -->
      <Ayarlar />
  </div>

  <div class="sütun-7 sütun-k-9">
    <!-- içerik bölümü -->
      <Muhteva />
  </div>

  <div class="sütun-2 sütun-k-12 ayarlar">
    <!-- dil listesi bölümü -->
      <Diller />
  </div>

</div>

<!-- alt bölümü -->
  <Alt />




